import React from "react";
import { round } from "lodash";

import CustomProductName from "@/components/desktop/products/product_name/CustomProductName";
import { formatMiles, formatMilesDecimalNew } from "@/services/Utils";

import classes from "../orderApplication.module.scss";

const AppOrdersDetail = ({ indice, application_order, isCopy }) => {
	let showItems = application_order?.items || [];
	if (application_order.calculated_machined) {
		if (isCopy) {
			showItems = application_order?.items?.filter((item) => item.isCopy);
		} else {
			showItems = application_order?.items?.filter((item) => !item.isCopy);
		}
	}

	if (showItems.length === 0) {
		return null;
	}

	return (
		<div key={indice} className={classes.detail_div_table}>
			{Number(application_order.application_order_type_id) !== 2 && (
				<h4 style={{ fontSize: "13px", textAlign: "start" }}>
					{`${formatMilesDecimalNew(showItems[0]?.quantity_machinery || 0)} maquinadas con ${
						formatMilesDecimalNew(showItems[0]?.machined) || formatMiles(round(application_order?.application_orders_machineries_machined, 2)) || 0
					} litros`}
				</h4>
			)}

			<table className={classes.detail_table}>
				<thead>
					<tr className={classes.detail_tr_head}>
						<th className={classes.detail_th} style={{ width: "40%", fontSize: "10px", verticalAlign: "middle" }}>
							Producto
						</th>
						<th className={classes.detail_th} style={{ width: "20%", fontSize: "10px", verticalAlign: "middle" }}>
							Objetivo
						</th>
						<th className={classes.detail_th} style={{ width: "20%", fontSize: "10px", verticalAlign: "middle" }}>
							{Number(application_order.application_order_type_id) === 2 ? "Dosis (L,Kg) por Ha" : "Dosis/100L"} <br />
						</th>
						<th className={classes.detail_th} style={{ width: "20%", fontSize: "10px", verticalAlign: "middle" }}>
							Cant. Producto (L/Kg)
						</th>
					</tr>
				</thead>
				<tbody>
					{showItems.map((item, index) => (
						<tr key={index}>
							<td>
								<div style={{ display: "flex", fontSize: "11px" }}>
									<CustomProductName
										product={{
											code: item.product_code,
											value: item.product_id,
											label: item.product_name,
										}}
									/>
								</div>
								{item.product_options &&
									item.product_options.length > 0 &&
									item.product_options.map((option, indexOption) => (
										<React.Fragment key={indexOption}>
											<span style={{ fontSize: "11px" }}>{` o ${option.product_name}`}</span>
											<br />
										</React.Fragment>
									))}
							</td>
							<td style={{ fontSize: "11px" }}>{item.application_orders_objetives_name}</td>
							<td>
								{Number(application_order.application_order_type_id) === 2
									? formatMilesDecimalNew(item.dose_ha)
									: formatMilesDecimalNew(item.dose_100L)}
							</td>
							<td>{formatMilesDecimalNew(item.quantity)}</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};

export default AppOrdersDetail;
